import type { ThirdPartyProvidersFeatureConfig } from '../type';

export const thirdPartyProviders: Partial<ThirdPartyProvidersFeatureConfig> = {
    handoverTargetClientId: 'tppUrl',
};
